export const errors = [
  {
    code: 101,
    title: 'Error ao Iniciar o Editor',
  },
];



// WEBPACK FOOTER //
// ./src/pages/error/erros.js